import { useTrans } from "@/translations";

import { useMemo } from "react";

type Props = {
  active?: boolean;
  payload?: { value: number; dataKey: string }[];
  label?: string;
};

export const LostRecyclingRateTooltipContent: React.FC<Props> = ({
  active,
  payload,
  label,
}) => {
  const { t } = useTrans();
  const actual = useMemo(
    () => payload?.find((entry) => entry.dataKey === "actual")?.value,
    [payload],
  );
  const potential = useMemo(
    () => payload?.find((entry) => entry.dataKey === "potential")?.value,
    [payload],
  );

  const gap = useMemo(
    () =>
      actual != null && potential != null
        ? +(potential - actual).toFixed(1)
        : null,
    [actual, potential],
  );

  if (!active || !payload?.length) {
    return null;
  }

  return (
    <div className="rounded-lg bg-[#1D1C1C] px-[12px] py-[9px] text-white">
      <div className="mb-[5px] text-[11.5px] font-bold">{label}</div>
      <div className="flex items-center justify-between gap-[16px] text-[13px]">
        <span className="inline-flex items-center gap-[6px]">
          <span className="h-[9px] w-[9px] rounded-[2px] bg-[#467432]" />
          {t("contaminationPage:recyclingRateLostTooltipWithout")}
        </span>
        <b>{potential} %</b>
      </div>
      <div className="mt-[2px] flex items-center justify-between gap-[16px] text-[13px]">
        <span className="inline-flex items-center gap-[6px]">
          <span className="h-[9px] w-[9px] rounded-[2px] bg-white" />
          {t("contaminationPage:recyclingRateLostTooltipActual")}
        </span>
        <b>{actual} %</b>
      </div>
      {gap != null && (
        <div className="mt-[5px] flex items-center justify-between gap-[16px] border-t border-white/20 pt-[5px] text-[13px]">
          <span>
            {t("contaminationPage:recyclingRateLostTooltipLostValue")}
          </span>
          <b className="text-carrot">
            {gap}
            {t("common:percentagePoints")}
          </b>
        </div>
      )}
    </div>
  );
};
